/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { StatusBadge } from "@octopusdeploy/design-system-components";
import type { MachineModelHealthStatus, SummaryResource } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { DisabledMachineIcon } from "~/areas/infrastructure/components/MachineHealthStatusIcons/DisabledMachineIcon";
import InternalLink from "~/components/Navigation/InternalLink";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
import styles from "../style.module.less";
import { HealthStatusContentIconContainer } from "./HealthStatusContentIconContainer";
import { HealthStatusContentRow } from "./HealthStatusContentRow";
const disabledComponentKey = "Disabled";
interface HealthStatusContentProps {
    summaryResource: SummaryResource;
    link: (obj: HealthStatusContentFilter) => LinkHref;
}
export interface HealthStatusContentFilter {
    isDisabled?: boolean;
    healthStatuses?: MachineModelHealthStatus[];
}
export const HealthStatusContent = ({ summaryResource, link }: HealthStatusContentProps) => {
    const isNewStatusIconsFeatureEnabled = useOctopusFeatureToggle("new-status-icons", false);
    return (<div className={styles.cardContentContainerRows}>
            {Object.keys(summaryResource.MachineHealthStatusSummaries).map((k: string) => {
            const status = k as MachineModelHealthStatus;
            return <HealthStatusContentRow key={k} summaryResource={summaryResource} link={link} status={status}/>;
        })}
            <div className={styles.healthStatusRowsContainer} key={disabledComponentKey}>
                <HealthStatusContentIconContainer>{isNewStatusIconsFeatureEnabled ? <StatusBadge status="disabled"/> : <DisabledMachineIcon iconSize="medium"/>}</HealthStatusContentIconContainer>

                <div className={styles.healthStatusName}>
                    <InternalLink to={link({ isDisabled: true })}>Disabled</InternalLink>
                </div>
                <div className={styles.healthStatusMachinesCount}>{summaryResource.TotalDisabledMachines.toLocaleString()}</div>
            </div>
        </div>);
};
